import {jsonRoute} from '@github-ui/react-core/json-route'
import {registerNavigatorApp} from '@github-ui/react-core/register-app'

import {App} from './App'
import ActivityIndex from './pages/ActivityIndex'

registerNavigatorApp('activity', () => ({
  App,
  routes: [jsonRoute({path: '/:owner/:repo/activity', Component: ActivityIndex})],
}))
